import request from '@/utils/request'
import https from '@/utils/https.js'
export function geDicList() {
    return request({
        showLoading: false,
        url: '/web/college/search_dic',
        method: 'post',
        data: {
        }
    })
}

export function getBaseData() {
    return https({
        url: '/api/special_subject/get_basedata',
        method: 'post',
        data: {}
    })
}

export function getSubjectToMajorList(data) {
    return https({
        url: '/api/special_subject/subj_spec_list',
        method: 'post',
        data: {
        subject: data.subject || '',
        key_word: data.key_word || '',
        gradation: data.gradation || '0',
        scl_nature_type: data.scl_nature_type || '',
        province_id: data.province_id || '',
        scl_type: data.scl_type || '',
        scl_nature: data.scl_nature || '',
        local_batch_id: data.local_batch_id || '',
        master_doctor: data.master_doctor || '',
        year: data.year || '',
        page: data.page,
        limit: data.page_size
        }
    })
}

export function getMajorCombinationList(data) {
    return https({
        url: '/api/special_subject/subj_arr',
        method: 'post',
        data: {
        ssp_ids: data.ssp_ids
        }
    })
}

export function getMajorToSubjectList(data) {
    return https({
        url: '/api/special_subject/spec_subj_list',
        method: 'post',
        data: {
        spec_id: data.spec_id || '',
        key_word: data.key_word || '',
        gradation: data.gradation || '0',
        scl_nature_type: data.scl_nature_type || '',
        province_id: data.province_id || '',
        scl_type: data.scl_type || '',
        scl_nature: data.scl_nature || '',
        local_batch_id: data.local_batch_id || '',
        master_doctor: data.master_doctor || '',
        year: data.year || '',
        page: data.page,
        limit: data.page_size
        }
    })
}

export function getSpecialList(special_name, level1, level2, level3) {
    return https({
        showLoading: false,
        url: '/api/special/special_list',
        method: 'post',
        data: {
        special_name: special_name,
        level1: level1,
        level2: level2,
        level3: level3,
        page: 1,
        size: 300
        }
    })
}

export function getAllLevel2(level1) {
    return https({
        showLoading: false,
        url: '/api/Special/getAllLevel2',
        method: 'post',
        data: {
        level1: level1
        }
    })
}

export function getAllLevel3(data) {
    return https({
        showLoading: false,
        url: '/api/special/all_level3',
        method: 'post',
        data: {
        level1: data.level1,
        level2: data.level2
        }
    })
}
